module.exports = __webpack_public_path__ + "img/clothing_fashion_qr_code.b8ddfee2.png";